export interface ArtistInstructionsArtwork {
  id: number;
  enhancementTier?: string;
  enhancementNote?: string;
  llmInterpretationState?: LlmInterpretationState;
  llmRedrawRequestId?: number;
}

export interface LlmInterpretationState {
  currentState: string;
  instructions: string;
  questions: Question[];
  previousState: string | undefined;
  previousInstructions: string;
  previousQuestions: Question[];
  llmRedrawRequestId?: number;
}

export interface Question {
  title: string;
  options: string[];
  answer: string | undefined;
}

export const ARTIST_INSTRUCTIONS_STATES = {
  INITIAL: "initial",
  TYPING: "typing",
  QUESTIONS: "questions",
  FINAL: "final"
} as const;

export type ArtistInstructionsState =
  (typeof ARTIST_INSTRUCTIONS_STATES)[keyof typeof ARTIST_INSTRUCTIONS_STATES];
